<template>
<v-container>
<v-btn @click="type_selector = true">
    <v-icon>mdi-download</v-icon>
</v-btn>
<v-dialog v-model="dialog" max-width="400px">
    <month-picker :no-default="true" @input="download" lang="ko" ></month-picker>
</v-dialog>

<form ref="down" :action="down_url" v-show="false" method="POST">
    <input name="year" ref="year"/>
    <input name="month" ref="month" />
    <input name="type" ref="type" />
    <input name="_session_" ref="session" />
</form>

</v-container>
    
</template>
<script>
import Swal from 'sweetalert2'
export default {
    name: 'HistoryDownloader',
    watch: {
        type_selector() {
            if (this.type_selector) {
                Swal.fire({
                    title: 'Which one do you download?',
                    showDenyButton: true,
                    confirmButtonText: 'confirmation history',
                    denyButtonText: 'request history',
                    denyButtonColor: '#123' 
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        this.$refs.type.value = 'confirmation'
                        this.dialog = true
                    } else if(result.isDenied) {
                        this.$refs.type.value = 'request'
                        this.dialog = true
                    }
                    this.type_selector = false
                })
            }
        }
    },
    methods: {
        download(e) {
            this.$refs.year.value = e.year
            this.$refs.month.value = e.monthIndex
            this.$refs.session.value = localStorage.getItem('_session_')
            this.$refs.down.submit();
            this.dialog = false
        }
    },
    data() {
        return {
            down_url: `${process.env.VUE_APP_BACKEND}/download`,
            dialog: false,
            type_selector: false,
        }
    }
}
</script>
